import { render } from "./AiGeneration.vue?vue&type=template&id=0a23eb13&scoped=true"
import script from "./AiGeneration.vue?vue&type=script&lang=js"
export * from "./AiGeneration.vue?vue&type=script&lang=js"

import "./AiGeneration.vue?vue&type=style&index=0&id=0a23eb13&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a23eb13"]])

export default __exports__